import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ModuleCard } from '../moduleCard';
import { DraggingModuleContext } from 'src/modules/contentList/contexts/draggingModuleContext';
import { DraggingPageContext } from 'src/modules/contentList/contexts/draggingPageContext';
import { useModuleDragAndDrop } from 'src/modules/contentList/hooks/useModuleDragAndDrop';
export function ModuleList({ modules }) {
    const [draggingPageId, setDraggingPageId] = useState(null);
    const [draggingModuleId, setDraggingModuleId] = useState(null);
    const { modulesCopy, parentRef } = useModuleDragAndDrop({
        modules,
        setDraggingModuleId
    });
    return (_jsx(DraggingModuleContext.Provider, { value: { draggingModuleId, setDraggingModuleId }, children: _jsx(DraggingPageContext.Provider, { value: { draggingPageId, setDraggingPageId }, children: _jsx("ul", { className: "flex flex-col gap-4", ref: parentRef, children: modulesCopy.map((module) => (_jsx(ModuleCard, { module: module, isDragging: draggingModuleId === module.id }, module.id))) }) }) }));
}
